interface ShippingSla {
  shippingEstimate: string | null
  id: string
  name: string
  deliveryIds: Array<{
    courierId: string
    warehouseId: string
    dockId: string
    courierName: string
    quantity: number
    kitItemDetails?: any[]
  }>
  price: number
  listPrice: number
  tax: number
  pickupStoreInfo: {
    isPickupStore: boolean
    friendlyName: string | null
    address: any
    additionalInfo: string | null
    dockId: string | null
  }
  pickupPointId: string | null
  shippingEstimateDate: string | null
  transitTime?: string
  deliveryWindow?: any
  deliveryChannel?: string
  availableDeliveryWindows?: any[]
  lockTTL?: string | null
  polygonName?: string
}

export const getDeliveryType = (
  slas: (ShippingSla | null | false)[] | undefined
): 'encomendavel' | 'pronta_entrega' | 'nao_regionalizado' => {
  if (!slas || !Array.isArray(slas) || slas.length === 0) {
    return 'nao_regionalizado'
  }

  const DELIVERY_THRESHOLD = 30

  const deliverySla = slas.find(
    (sla) =>
      sla &&
      sla.deliveryChannel === 'delivery' &&
      /^\d+bd$/.test(sla.shippingEstimate ?? '')
  )

  if (!deliverySla) {
    return 'pronta_entrega'
  }

  const estimateDays = parseInt(deliverySla.shippingEstimate!.replace('bd', ''), 10)

  return estimateDays > DELIVERY_THRESHOLD ? 'encomendavel' : 'pronta_entrega'
}